__turbopack_context__.v({
  "backdrop": "QuickLinks-module__iPfPha__backdrop",
  "closeButton": "QuickLinks-module__iPfPha__closeButton",
  "container": "QuickLinks-module__iPfPha__container",
  "floatingButton": "QuickLinks-module__iPfPha__floatingButton",
  "heading": "QuickLinks-module__iPfPha__heading",
  "hidden": "QuickLinks-module__iPfPha__hidden",
  "revision": "QuickLinks-module__iPfPha__revision",
});
